module.exports = "<ul class=\"nav nav-tabs\">\n  <li class=\"nav-item\" *ngFor=\"let tab of tabs\">\n    <a class=\"nav-link\" (click)=\"selectTab(tab)\" [class.active]=\"tab.active\">{{tab.title}}</a>\n  </li>\n</ul>\n<div class=\"tab-content\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/custom-tabs/custom-tabs.html
// module id = ./src/app/shared/components/custom-tabs/custom-tabs.html
// module chunks = main